// import api from "../../../../../api";
// import React from "react";
// import values from "../../../../../values";
import React, { useState } from "react";
import { TModal } from "../../../../../../../types/common.type";
import { useQuery } from "react-query";
import values from "../../../../../../../values";
import api from "../../../../../../../api";
import {
  IFindApproveParentTransaction,
  IFindTransaction,
} from "../../../../../../../types/common.interface";
import Context from "../../../../../../../context";
import FindDebtScreen from "..";
import utils from "../../../../../../../utils";
import { IPayDebtToDriver } from "../../../../../../../types/company.interface";

// import {useQuery} from "react-query";
// import {DebtContext} from "../../../../../context";

// type TModal = "SHOW" | "NONE" | "SETUP_ORDER";

const RejectedParentTransactionContainer = () => {
  // ** ==============================================================================================================
  // **                                         Values Validations
  // ** ==============================================================================================================
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [showModal, setShowModal] = React.useState<TModal>("NONE");
  const [selectedPayment, setSelectedPayment] = useState<any>();

  // !! ==============================================================================================================
  // !!                                           Start API Call
  // !! ==============================================================================================================

  const [requestApproveParentTransaction, setRequestApproveParentTransaction] =
    React.useState<IFindApproveParentTransaction>({
      page: 1,
      limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
    });

  // ? Panel-wide academic year (سال تحصیلی). It has to be in the query key as well as the request, otherwise
  // ? react-query serves the previous year's cached rows when the year is switched.
  const { selectedYear } = React.useContext(Context.AcademicYear);

  const approvedParentTransaction = useQuery(
    [
      values.useQueryKeys.rejectedParentTransaction,
      requestApproveParentTransaction,
      selectedYear?._id,
    ],
    () =>
      api.post.administrator.findRejectedParentTransaction({
        ...requestApproveParentTransaction,
        academicYear: selectedYear?._id,
      })
  );
  // !! ==============================================================================================================
  // !!                                            End API Call
  // !! ==============================================================================================================

  // ?? ==============================================================================================================
  // ??                                            JSX Container
  // ?? ==============================================================================================================

  return (
    <Context.RejectedParentTransaction.Provider
      value={{
        isLoading,
        showModal,
        setIsLoading,
        setShowModal,
        requestApproveParentTransaction,
        setRequestApproveParentTransaction,
        approvedParentTransaction,
        selectedPayment,
        setSelectedPayment,
      }}
    >
      <FindDebtScreen rqData={approvedParentTransaction} showModalData={{}} />
    </Context.RejectedParentTransaction.Provider>
  );
};

export default RejectedParentTransactionContainer;
